import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Icomoon__checkmark",
  "use": "Icomoon__checkmark-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"Icomoon__checkmark\"><path d=\"M432 64 192 304 80 192 0 272l192 192 320-320z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol